export const userApiURL = {
  userDetails: "/user/details",
  userCompanyDetails: "/user/company",
  userRolesDetails: "/user/roles",
  resetPassword: "/user/reset-password",
};
